import {createAction, ActionFunction1, Action, ActionFunctionAny} from 'redux-actions';
import {AudioTrackData} from '../AudioTracksTypes';

export const AUDIO_TRACK_DATA_SET = 'AUDIO_TRACK_DATA_SET';
export const AUDIO_TRACK_DATA_RESET = 'AUDIO_TRACK_DATA_RESET';
export const AUDIO_TRACKS_DATA_RESET = 'AUDIO_TRACKS_DATA_RESET';
export const AUDIO_TRACK_ENABLE = 'AUDIO_TRACK_ENABLE';
export const AUDIO_TRACK_DISABLE = 'AUDIO_TRACK_DISABLE';
export const AUDIO_CHANNEL_ENABLE = 'AUDIO_CHANNEL_ENABLE';
export const AUDIO_CHANNEL_DISABLE = 'AUDIO_CHANNEL_DISABLE';
export const AUDIO_AVAILABLE_CHANNEL_OUTPUT_SET = 'AUDIO_AVAILABLE_CHANNEL_OUTPUT_SET';

export type AudioTrackDataPayload = AudioTrackData | null;
type PartialAudio = Partial<AudioTrackDataPayload>;

export interface AudioChannelDataPayload {
    trackData: AudioTrackData | null;
    channel: number;
}

export type AudioAvailableChannelOutputPayload = number;

export type SetAudioTrack = ActionFunction1<AudioTrackDataPayload, Action<AudioTrackDataPayload>>;
export type EnableAudioTrack = ActionFunction1<AudioTrackDataPayload, Action<AudioTrackDataPayload>>;
export type DisableAudioTrack = ActionFunction1<AudioTrackDataPayload, Action<AudioTrackDataPayload>>;
export type ResetAudioTrack = ActionFunction1<PartialAudio, Action<PartialAudio>>;
export type ResetAudioTracks = ActionFunctionAny<Action<any>>;
export type EnableAudioChannel = ActionFunction1<AudioChannelDataPayload, Action<AudioChannelDataPayload>>;
export type DisableAudioChannel = ActionFunction1<AudioChannelDataPayload, Action<AudioChannelDataPayload>>;
export type SetAudioAvailableChannelOutput = ActionFunction1<AudioAvailableChannelOutputPayload, Action<AudioAvailableChannelOutputPayload>>;

export const setAudioTrackAction = createAction<AudioTrackDataPayload>(AUDIO_TRACK_DATA_SET);

export const enableAudioTrackAction = createAction<AudioTrackDataPayload>(AUDIO_TRACK_ENABLE);

export const disableAudioTrackAction = createAction<AudioTrackDataPayload>(AUDIO_TRACK_DISABLE);

export const enableAudioChannelAction = createAction<AudioChannelDataPayload>(AUDIO_CHANNEL_ENABLE);

export const disableAudioChannelAction = createAction<AudioChannelDataPayload>(AUDIO_CHANNEL_DISABLE);

export const resetAudioTrackAction = createAction<Partial<AudioTrackDataPayload>>(AUDIO_TRACK_DATA_RESET);

export const resetAudioTracksAction = createAction(AUDIO_TRACKS_DATA_RESET);

export const setAudioAvailableChannelOutputAction = createAction<AudioAvailableChannelOutputPayload>(AUDIO_AVAILABLE_CHANNEL_OUTPUT_SET);
